import '../src/styles/app.scss';

export { default } from '@abyss/core/next-app';
